import { useState } from 'react';
import { Row, Col } from 'antd';
import { PageHero } from '@/components/PageHero';
import { PictureOutlined } from '@ant-design/icons';
import { GeneratePanel } from './GeneratePanel';
import { MediaLibrary } from './MediaLibrary';

export function AiStudioPage() {
  const [refreshKey, setRefreshKey] = useState(0);
  return (
    <div style={{ maxWidth: 1200 }}>
      <PageHero icon={<PictureOutlined />} title="AI Studio" subtitle="Generate marketing images & videos for programs" />
      <Row gutter={16}>
        <Col xs={24} md={9}><GeneratePanel onGenerated={() => setRefreshKey((k) => k + 1)} /></Col>
        <Col xs={24} md={15}><MediaLibrary refreshKey={refreshKey} /></Col>
      </Row>
    </div>
  );
}
